import React from "react";
import "./HeroSection.scss";
import { Row, Col, Button, Layout } from "antd";
import { useEffect } from "react";
import { PORTAL_BASE_URL } from "../../../env";
import ModelViewer from "../../landingPage/sectionTwo/modelViewer";
const { Content } = Layout;

const HeroSection = () => {
    return (
        <>
            <WebVersion />
            <MobileVersion />
        </>
    );
}

const WebVersion = () => {
    const utm_source = localStorage.getItem('utm_source') || null;
    const redirectPath = `/select-subscription?plan=free_trial&plan_type=smb_hero_section&utm_source=${utm_source}`;

    return (<Content className="d-none d-lg-block">
        <Row className="container-fluid justify-in-start hero-section">

            <Col span={10}>
                <div className="hero-model-section">
                    <img src={'/smb/hero/ipad.png'} className="img-1" />
                    <img src={'/smb/hero/bag.svg'} className="img-2" />

                    <div className="model-hero-section-container">
                        <ModelViewer class='model-hero-section'
                            ar={false}
                            poster={"https://d48f7equ64qjl.cloudfront.net/product_assets/perspective_renders/846_FrontAngled.jpg"}
                            src={"https://d48f7equ64qjl.cloudfront.net/product_assets/glb/846.glb"}
                        />
                    </div>

                    <img src={'/smb/hero/watch.svg'} className="img-3" />
                    <img src={'/smb/hero/nailpolish.png'} className="img-4" />
                </div>
            </Col>

            <Col span={12} className="pd-24">
                <p className="manrope f-16 w-700 black-085 lh-24 mb-32">
                    3D Visualization for Ecommerce
                </p>

                <h1 className="manrope f-38 w-600 black-085 lh-46 mb-16">
                    Immersive 3D solutions at scale to sell more -- all within your budget
                </h1>
                <h5 className="manrope f-16 w-500 black-085 lh-24 mb-32">
                    Create premium listings and boost sales with cost-effective, scalable and immersive 3D visualization that stands out in a competitive marketplace.
                </h5>
                <div className="justify-in-start">
                    <Button onClick={() =>
                        window.open(`${PORTAL_BASE_URL}/register?redirectURL=${encodeURIComponent(redirectPath)}`, "_blank")
                    }
                        type="primary"
                        className={`manrope f-16 w-700 lh-24 blue-button`}

                    >
                        Get started for free
                    </Button>
                    <img src="/smb/logo-amazon-spn.png" className="ml-24  amazon-icon-size" />
                </div>
            </Col>
        </Row>
    </Content>)
}

const MobileVersion = () => {
    const utm_source = localStorage.getItem('utm_source') || null;
    const redirectPath = `/select-subscription?plan=free_trial&plan_type=smb_hero_section&utm_source=${utm_source}`;
    return (<Content className="d-lg-none">
        <Row className="container-fluid hero-section">
            <Col span={24}>
                <p className="manrope f-16 w-700 black-085 lh-24 mb-16 text-left">
                    3D Visualization for Ecommerce
                </p>
                <h1 className="manrope f-30 w-600 black-085 lh-40 mb-16">
                    Immersive 3D solutions at scale to sell more -- all within your budget
                </h1>
                <h5 className="manrope f-16 w-500 black-085 lh-24 mb-24">
                    Create premium listings and boost sales with cost-effective, scalable and immersive 3D visualization that stands out in a competitive marketplace.
                </h5>
                <Button onClick={() =>
                    window.open(`${PORTAL_BASE_URL}/register?redirectURL=${encodeURIComponent(redirectPath)}`, "_blank")
                }
                    className={`manrope f-16 w-700 lh-24 blue-button w-100 centerCarousel mb-24`}
                >
                    Get started for free
                </Button>
                <img src="/smb/logo-amazon-spn.png" className="justify-in-center centerCarousel mb-24 amazon-icon-size" />
            </Col>
            <Col span={24} className="justify-in-center height-max-c">
                <div className="hero-model-section">
                    <img src={'/smb/hero/ipad.png'} className="img-1" />
                    <img src={'/smb/hero/bag.svg'} className="img-2" />

                    <div className="model-hero-section-container">
                        <ModelViewer class='model-hero-section'
                            ar={false}
                            poster={"https://d48f7equ64qjl.cloudfront.net/product_assets/perspective_renders/846_FrontAngled.jpg"}
                            src={"https://d48f7equ64qjl.cloudfront.net/product_assets/glb/846.glb"}
                        />
                    </div>

                    <img src={'/smb/hero/watch.svg'} className="img-3" />
                    <img src={'/smb/hero/nailpolish.png'} className="img-4" />
                </div>
                {/* <img src='/smb/hero.svg' className="hero-smb-img" /> */}
            </Col>
        </Row>
    </Content>)
}


export default HeroSection;
